import { useImpersonation } from '@/context/ImpersonationContext';
import { Button } from '@/components/ui/button';
import { Eye, LogOut, Loader2 } from 'lucide-react';
import { useLocation } from 'wouter';
import { useToast } from '@/hooks/use-toast';

export function ImpersonationBanner() {
  const { impersonation, endImpersonation, isLoading } = useImpersonation();
  const [, navigate] = useLocation();
  const { toast } = useToast();

  const handleExitViewAs = async () => {
    // Navigate first to avoid a flash of the invoice dashboard re-rendering as admin
    // before the route change (see prior UX fix).
    navigate('/admin/users');
    try {
      await endImpersonation();
    } catch (err) {
      toast({
        title: 'Error',
        description: err instanceof Error ? err.message : 'Failed to exit View As',
        variant: 'destructive',
      });
    }
  };

  if (!impersonation.active) return null;

  return (
    <div
      data-app-chrome
      className="bg-amber-900 text-white px-4 py-2 flex items-center justify-between gap-3 z-50 shadow-md"
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="h-4 w-4 shrink-0" />
        <span>
          Viewing as{' '}
          <strong>{impersonation.targetDisplayName}</strong>
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleExitViewAs}
        disabled={isLoading}
        className="bg-amber-100 border-amber-300 text-amber-950 hover:bg-amber-200 hover:text-amber-950 h-7 text-xs"
      >
        {isLoading ? (
          <Loader2 className="h-3 w-3 animate-spin mr-1" />
        ) : (
          <LogOut className="h-3 w-3 mr-1" />
        )}
        Exit View As
      </Button>
    </div>
  );
}
